import React from "react";
import logo from '../assets/images/logo.png';
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

type Props = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  gap?: number;
};

export default function SixFortyLayout({ left, right, gap = 2 }: Props) {
  return (
     <Container disableGutters maxWidth="xl" sx={{ p: 0, m: 0,
		background:
            "linear-gradient(to right, black 0%, var(--primary-color) 100%, #fff 100%)",

      }}>
      <Box
        component="img"
        src={logo}
        alt="Vehicle Maintenance Pro Logo"
        sx={{
          width: "100px",
          borderRadius: "3px",
          borderBottom: "5px solid grey",
          // responsive positioning
          position: { xs: "relative", md: "absolute" },
          top: { xs: "4px", md: '8px' },
          left: { xs: "4px", md: '8px' },
          mx: { xs: "auto", md: 0 }, // center horizontally on mobile
          display: "block", // ensures mx:auto works
        }}
      />

      <Box
        component="section"
        sx={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          height: { xs: "auto", md: "100vh" },
          gap,
          background:
            "linear-gradient(to right, black 0%, var(--primary-color) 100%, #fff 100%)",
        }}
      >
        {/* Left (60%) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            background: "transparent",
            width: { xs: "100%", md: "60%" },
          }}
        >
          <Paper
            sx={{
              minHeight: 200,
              height: "100%",
              overflow: "hidden",
              borderRadius: "unset",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "transparent",
              boxShadow: "none",
              m: 1,
            }}
            elevation={12}
          >
            {left ?? (
              <>
                <Typography variant="h6">Left Section (60% - Wider)</Typography>
                <Typography>
                  This area takes full width on mobile and 60% on larger screens.
                </Typography>
              </>
            )}
          </Paper>
        </Box>

        {/* Right (40%) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", md: "40%" },
          }}
        >
          <Paper
            sx={{
              p: 2,
              minHeight: 200,
              height: "100%",
              overflow: "hidden",
              borderRadius: "unset",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "none",
            }}
            elevation={12}
          >
            {right ?? (
              <>
                <Typography variant="h6">Right Section (40% - Narrower)</Typography>
                <Typography>
                  This area takes full width on mobile and 40% on larger screens.
                </Typography>
              </>
            )}
          </Paper>
        </Box>
      </Box>
     </Container>
  );
}